import React from 'react';
import {UeThemeProvider, ueLightTheme, ueDarkTheme} from 'epic-ue-theme';
import {AnimateOnViewWrap} from '../../wraps';
import styled from 'styled-components';

const Styled = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 2;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    pointer-events: none;
    div {
        height: 100%;
        width: 100%;
    }
    .light-bg {
        background-color: ${(p) => p.theme.palette.neutral.pearl};
    }
    .dark-bg {
        background-color: ${(p) => p.theme.palette.neutral.charcoal};
    }
`;

/**
 * Must be wrapped in a position: relative container since it is positioned absolute
 */
export const FadeOutLightBackground = (): JSX.Element => {
    return (
        <Styled>
            <AnimateOnViewWrap fadeOut startingOpacity={1} duration={2.25}>
                <UeThemeProvider theme={ueLightTheme}>
                    <div className="light-bg" />
                </UeThemeProvider>
            </AnimateOnViewWrap>
        </Styled>
    );
};

/**
 * Must be wrapped in a position: relative container since it is positioned absolute
 */
export const FadeOutDarkBackground = (): JSX.Element => {
    return (
        <Styled>
            <AnimateOnViewWrap fadeOut startingOpacity={1} duration={2.25}>
                <UeThemeProvider theme={ueDarkTheme}>
                    <div className="dark-bg" />
                </UeThemeProvider>
            </AnimateOnViewWrap>
        </Styled>
    );
};
